import { apiUrls } from "../consts/ApiUrls";
import { portalApiClient } from "./apiClient";

export default async function getUsers(companyId) {
  const data = await portalApiClient.get(
    apiUrls.usersByCompanyId.url(companyId)
  );
  return data.data;
}

export async function getUserById(id: string | number) {
  const data = await portalApiClient.get(apiUrls.userById.url(id));
  return data.data;
}
